import React from 'react';
import { motion } from 'framer-motion';

export function Card({ children, className = '', animate = false, ...props }) {
  const Comp = animate ? motion.div : 'div';
  const animProps = animate
    ? { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.3 } }
    : {};

  return (
    <Comp className={`card ${className}`} {...animProps} {...props}>
      {children}
    </Comp>
  );
}

export function GoldCard({ children, className = '', ...props }) {
  return (
    <div className={`card-gold ${className}`} {...props}>
      {children}
    </div>
  );
}
